import React, { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import ScheduleSectionForm from '../../../../../ReusableFormSections/ScheduleSection/ScheduleSectionForm'

import { filterObjectEmptyValues } from '../../../../../../helpers/common'
import { formatScheduleDatesToBE, formatScheduleDatesToFE } from '../../../../../../features/formatters'

import { updateLineItem, clearUpdateLineItem } from '../../../../../../modules/actions/lineItems'
import {
  lineItemUpdateErrorSelector,
  lineItemUpdateIsLoadingSelector,
  lineItemWasUpdatedSelector
} from '../../../../../../modules/selectors/lineItems'
import { selectedTikTokAdAccountSelector } from '../../../../../../modules/selectors/adAccounts'

import { TIKTOK_PLATFORM } from '../../../../../../constants/selectLists/platformList'
import { HISTORY_META_EDIT_SECTION } from '../../../../../../constants/changeHistory'
import { SCHEDULE } from '../../../../../ReusableFormSections/ScheduleSection/fields'

function ScheduleSection({ editItemData: lineItem, title, ...formProps }) {
  const dispatch = useDispatch()

  const lineItemWasUpdated = useSelector(lineItemWasUpdatedSelector)
  const { id: tiktokAdAccountId } = useSelector(selectedTikTokAdAccountSelector)

  const { dayparting: schedule } = lineItem

  const formattedSchedule = formatScheduleDatesToFE(schedule)

  const handleSubmit = useCallback(
    values => {
      // as we use PUT for update tiktok campaign, we should pass full data in payload
      dispatch(
        updateLineItem(
          {
            ...filterObjectEmptyValues(lineItem),
            account: tiktokAdAccountId,
            dayparting: formatScheduleDatesToBE(values[SCHEDULE]),
            meta: {
              [HISTORY_META_EDIT_SECTION]: title
            }
          },
          lineItem.id,
          TIKTOK_PLATFORM,
          {
            requestMethod: 'PUT'
          }
        )
      )
    },
    [dispatch, lineItem, tiktokAdAccountId, title]
  )

  const handleClearUpdateLineItem = useCallback(() => {
    dispatch(clearUpdateLineItem())
  }, [dispatch])

  return (
    <ScheduleSectionForm
      schedule={formattedSchedule}
      handleSubmit={handleSubmit}
      clearEditItem={handleClearUpdateLineItem}
      successSubmit={lineItemWasUpdated}
      isLoadingSelector={lineItemUpdateIsLoadingSelector}
      errorSelector={lineItemUpdateErrorSelector}
      {...formProps}
    />
  )
}

export default ScheduleSection
